// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-icon {
  color: #ed143d;
  font-size: 20px !important;
  margin-right: 10px;
}

ion-select::part(label) {
  color: #888;
  font-size: 17px;
}

ion-select::part(container) {
  font-size: 15px;
}

ion-select::part(icon) {
  color: #ed143d;
  transform: translateY(10px);
}

ion-select {
  transform: translateY(-4px);
}

.settings-section {
  background-color: #efefef;
  border-radius: 8px;
  margin: 0 0 10px 0;
  padding: 0 4px 0 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/datetime-format-setting/datetime-format-setting.component.scss"],"names":[],"mappings":"AAIA;EACE,cAAA;EACA,0BAAA;EACA,kBAAA;AAHF;;AAKA;EACE,WAAA;EACA,eAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,cAAA;EACA,2BAAA;AAFF;;AAIA;EACE,2BAAA;AADF;;AAGA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;AAAF","sourcesContent":["// ion-select::part(icon) {\n//   display: none;\n// }\n\nion-icon {\n  color:#ed143d;\n  font-size: 20px !important;\n  margin-right: 10px;\n}\nion-select::part(label) {\n  color: #888;\n  font-size: 17px;\n}\n\nion-select::part(container) {\n  font-size: 15px;\n}\n\nion-select::part(icon) {\n  color: #ed143d;\n  transform: translateY(10px);\n}\nion-select {\n  transform: translateY(-4px);\n}\n.settings-section {\n  background-color: #efefef;\n  border-radius: 8px;\n  margin: 0 0 10px 0;\n  padding: 0 4px 0 8px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
